import { defineStore } from 'pinia';

export const useNetworkStore = defineStore('network', {
  state: () => ({
    retryCount: 0,
    showModal: false,
    showButton: false,
  }),
  actions: {
    setRetryCount(count: number) {
      this.retryCount = count;
    },
    showRetryModal(visible: boolean) {
      this.showModal = visible;
    },
    showRefreshButton(visible: boolean) {
      this.showButton = visible;
    },
  },
});
